function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { cloneElement } from "react";
import Checkbox from "../Checkbox/index";
import { useStyle } from "./CheckboxGroup.style";
import useLabelStyle from "../../Label/Label.style";
import HelperText from "../../HelperText";
import { resolveIds } from "../../../utils";
var CheckboxGroup = function(_param) {
    var children = _param.children, disabled = _param.disabled, groupLabel = _param.groupLabel, hasError = _param.hasError, helperText = _param.helperText, hideLabel = _param.hideLabel, id = _param.id, inline = _param.inline, isDisabled = _param.isDisabled, isRequired = _param.isRequired, isRtl = _param.isRtl, labelRequiredTitle = _param.labelRequiredTitle, labelText = _param.labelText, name = _param.name, onUpdate = _param.onUpdate, options = _param.options, required = _param.required, _selected = _param.selected, selected = _selected === void 0 ? [] : _selected, showLegend = _param.showLegend, testID = _param.testID, rest = _objectWithoutProperties(_param, [
        "children",
        "disabled",
        "groupLabel",
        "hasError",
        "helperText",
        "hideLabel",
        "id",
        "inline",
        "isDisabled",
        "isRequired",
        "isRtl",
        "labelRequiredTitle",
        "labelText",
        "name",
        "onUpdate",
        "options",
        "required",
        "selected",
        "showLegend",
        "testID"
    ]);
    var ref, ref1;
    var ref2 = useLabelStyle({
        hasStartIcon: false,
        isAnimated: false,
        isDisabled: (ref = isDisabled !== null && isDisabled !== void 0 ? isDisabled : disabled) !== null && ref !== void 0 ? ref : false,
        isRequired: (ref1 = isRequired !== null && isRequired !== void 0 ? isRequired : required) !== null && ref1 !== void 0 ? ref1 : false,
        isRtl: isRtl !== null && isRtl !== void 0 ? isRtl : false,
        variant: 'default'
    }), label = ref2.label, legendRequired = ref2.required;
    var ref3 = resolveIds(id, testID, 'helper-text', true), helperTextId = ref3.id, helperTextTestID = ref3.testID;
    var handleChange = function(param) {
        var target = param.target;
        var checked = target.checked, value = target.value;
        var selectedBoxes = selected;
        if (checked && !selectedBoxes.includes(value) && onUpdate) {
            return onUpdate(selectedBoxes.concat([
                value
            ]), options);
        }
        if (!checked && selectedBoxes.includes(value) && onUpdate) {
            return onUpdate(selectedBoxes.filter(function(currentValue) {
                return currentValue !== value;
            }), options);
        }
    };
    var checkboxesFromChildrenOrOptions = function() {
        var uniqueId = function(value) {
            return "".concat("".concat(name, "_")).concat(value);
        };
        if (children) {
            return React.Children.map(children, function(CheckboxOption) {
                return cloneElement(CheckboxOption, _objectSpread({}, CheckboxOption.props, {
                    name: name,
                    hasError: hasError,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : disabled,
                    isRtl: isRtl,
                    id: uniqueId(CheckboxOption.props.value)
                }));
            });
        }
        if (options) {
            var _isDisabled;
            return options.map(function(checkbox) {
                return _createElement(Checkbox, _objectSpread({}, checkbox, {
                    name: name,
                    hasError: hasError,
                    disabled: ((_isDisabled = checkbox.isDisabled) !== null && _isDisabled !== void 0 ? _isDisabled : checkbox.disabled) || (isDisabled !== null && isDisabled !== void 0 ? isDisabled : disabled),
                    isRtl: isRtl,
                    required: isRequired !== null && isRequired !== void 0 ? isRequired : required,
                    checked: selected && selected.includes(checkbox.value),
                    onChange: handleChange,
                    id: uniqueId(checkbox.value),
                    key: uniqueId(checkbox.value)
                }), checkbox.label || checkbox.value);
            });
        }
        return null;
    };
    var ref4;
    var ref5 = useStyle({
        inline: inline,
        showLegend: (ref4 = hideLabel === false) !== null && ref4 !== void 0 ? ref4 : showLegend,
        isRtl: isRtl
    }), legend = ref5.legend, fieldset = ref5.fieldset, container = ref5.container;
    return _jsxs("div", {
        css: container,
        children: [
            _jsxs("fieldset", _objectSpread({
                css: fieldset
            }, resolveIds(id, testID), rest, {
                "aria-describedby": [
                    rest === null || rest === void 0 ? void 0 : rest['aria-describedby'],
                    id && helperText && helperTextId
                ].filter(Boolean).join(' ') || undefined,
                children: [
                    _jsx("legend", {
                        css: (hideLabel !== null && hideLabel !== void 0 ? hideLabel : showLegend === false) ? legend : [
                            legend,
                            label
                        ],
                        children: _jsxs(_Fragment, {
                            children: [
                                (isRequired !== null && isRequired !== void 0 ? isRequired : required) && _jsx("abbr", {
                                    css: legendRequired,
                                    title: labelRequiredTitle,
                                    children: "*"
                                }),
                                labelText !== null && labelText !== void 0 ? labelText : groupLabel
                            ]
                        })
                    }),
                    checkboxesFromChildrenOrOptions()
                ]
            })),
            id && _jsx(HelperText, {
                hasError: hasError,
                id: helperTextId,
                isRtl: isRtl,
                testID: helperTextTestID,
                children: helperText
            })
        ]
    });
};
export { CheckboxGroup };
export default CheckboxGroup;
